'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $f_s_Product17__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.nR;
      break;
    }
    case 1: {
      return $thiz.o0;
      break;
    }
    case 2: {
      return $thiz.o1;
      break;
    }
    case 3: {
      return $thiz.o2;
      break;
    }
    case 4: {
      return $thiz.o3;
      break;
    }
    case 5: {
      return $thiz.o4;
      break;
    }
    case 6: {
      return $thiz.o5;
      break;
    }
    case 7: {
      return $thiz.o6;
      break;
    }
    case 8: {
      return $thiz.o7;
      break;
    }
    case 9: {
      return $thiz.nS;
      break;
    }
    case 10: {
      return $thiz.nT;
      break;
    }
    case 11: {
      return $thiz.nU;
      break;
    }
    case 12: {
      return $thiz.nV;
      break;
    }
    case 13: {
      return $thiz.nW;
      break;
    }
    case 14: {
      return $thiz.nX;
      break;
    }
    case 15: {
      return $thiz.nY;
      break;
    }
    case 16: {
      return $thiz.nZ;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 16)"));
    }
  }
}
export { $f_s_Product17__productElement__I__O as $f_s_Product17__productElement__I__O };
